import { combineReducers } from 'redux';
import {
  SET_SUBMISSION_MODAL,
  SET_TENOR_DATA,
  SET_PROVINCES,
  SET_CITIES,
} from 'actions/capital/constants';
import createReducer from 'utils/createReducer';

const submissionModal = createReducer(false, {
  [SET_SUBMISSION_MODAL]: (draft, { payload }) => payload.submissionModal,
});

const tenorData = createReducer([], {
  [SET_TENOR_DATA]: (draft, { payload }) => payload,
});

const provinces = createReducer([], {
  [SET_PROVINCES]: (draft, { payload }) => payload,
});

const cities = createReducer([], {
  [SET_CITIES]: (draft, { payload }) => payload,
});

const fastLoan = combineReducers({
  submissionModal,
  tenorData,
  provinces,
  cities,
});

export default fastLoan;
